import React, { useEffect, useState } from "react";
import TrackVisibility from "react-on-screen";
import Counter from "../elements/Counter";
import Pagetitle from "../elements/Pagetitle";
import Skill from "../elements/Skill";
import axios from "axios";
import { getStrapiURL } from "../../lib/api";

const aboutContent = {
  name: "Yas",
  avatarImage: "/images/avatar-2.svg",
  content:
    "I am Bolby Doe, web developer from London, United Kingdom. I have rich experience in web site design and building and customization, also I am good at WordPress.",
};

const progressData = [
  {
    id: 1,
    title: "Full-Stack Development (React, Node.js, TypeScript)",
    points: 95,
    color: "#FFD15C",
  },
  {
    id: 2,
    title: "Mobile Development (React Native, iOS/Android)",
    points: 92,
    color: "#FF4C60",
  },
  {
    id: 3,
    title: "Cloud Architecture & DevOps (AWS, Docker, CI/CD)",
    points: 88,
    color: "#6C6CE5",
  },
  {
    id: 4,
    title: "UI/UX Design & Performance Optimization",
    points: 90,
    color: "#44D7B6",
  },
];

const counterData = [
  {
    id: 1,
    title: "Years of Experience",
    count: 8,
    icon: "icon-fire",
    suffix: "+",
  },
  {
    id: 2,
    title: "Projects Completed",
    count: 50,
    icon: "icon-badge",
    suffix: "+",
  },
  {
    id: 3,
    title: "Happy Clients",
    count: 30,
    icon: "icon-people",
    suffix: "+",
  },
  {
    id: 4,
    title: "Technologies Mastered",
    count: 35,
    icon: "icon-cup",
    suffix: "+",
  },
];

function About() {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [about, setAbout] = useState({});

  // useEffect(() => {
  //   const fetchAboutData = async () => {
  //     setLoading(true);
  //     try {
  //       let url = getStrapiURL("/api/about?populate=aboutSkill&populate[1]=cv.file");
  //       const res = await axios.get(url);
  //       console.log("about data fetched", res.data.data);
  //       setAbout(res.data.data.attributes);
  //       console.log(
  //         "data fetched aboutskills",
  //         res.data.data.attributes.aboutSkill
  //       );
  //       setLoading(false);
  //     } catch (error) {
  //       setError(error);
  //       setLoading(false);
  //     }
  //   };
  //   fetchAboutData();
  // }, []);

  return (
    <section id="about">
      <div className="container">
        <Pagetitle title="About Me" />
        <div className="about-intro text-center mb-5">
          <h3 className="section-subtitle">Crafting Digital Excellence</h3>
          <p className="section-description">
            Transforming ideas into powerful, scalable solutions that drive business growth
          </p>
        </div>
        <div className="row">

          <div className="row fix-spacing">
            {counterData.map((counter) => (
              <div key={counter.id} className="col-md-3 col-sm-6">
                <TrackVisibility once>
                  <Counter counterItem={counter} />
                </TrackVisibility>
              </div>
            ))}
          </div>
          <div className="spacer" data-height="70"></div>
          <div className="col-md-3">
            <div className="text-center text-md-left">
              <img
                src="images/card.png"
                alt={'Professional developer portrait'}
              />
            </div>
            <div className="spacer d-md-none d-lg-none" data-height="30"></div>
          </div>
          <div className="col-md-9 triangle-left-md triangle-top-sm">
            <div className="rounded bg-white shadow-dark padding-30">
              <div className="row">
                <div className="col-md-6">
                  <h4 className="about-heading mb-3">
                    <span className="gradient-text">Who I Am</span>
                  </h4>
                  <p className="about-text">
                    I'm a <strong>Full-Stack Software Engineer</strong> specializing in building exceptional digital experiences. With expertise in <strong>React, React Native, TypeScript, and Node.js</strong>, I deliver scalable, performant applications that drive business results.
                  </p>
                  <h4 className="about-heading mb-3 mt-4">
                    <span className="gradient-text">My Approach</span>
                  </h4>
                  <p className="about-text">
                    I combine <strong>modern development practices</strong> with <strong>agile methodologies</strong>, ensuring projects are delivered on time with clean, maintainable code. My focus is on translating complex business requirements into elegant, user-centric technical solutions.
                  </p>
                  <h4 className="about-heading mb-3 mt-4">
                    <span className="gradient-text">My Passion</span>
                  </h4>
                  <p className="about-text">
                    Experienced in <strong>AI/ML integration</strong>, <strong>cloud architecture</strong>, and <strong>performance optimization</strong>. I stay current with emerging technologies to provide cutting-edge solutions for fintech, e-commerce, and enterprise SaaS applications.
                  </p>
                  <div className="mt-4 about-actions">
                    <a href={`https://github.com/cign`} className="btn btn-default btn-lg mr-3" download>
                      <i className="icon-cloud-download"></i> Download Resume
                    </a>
                    <a href="#section-contact" className="btn btn-outline btn-lg">
                      <i className="icon-bubbles"></i> Let's Talk
                    </a>
                  </div>
                  <div
                    className="spacer d-md-none d-lg-none"
                    data-height="30"
                  ></div>
                </div>
                <div className="col-md-6">
                  <h4 className="about-heading mb-4">
                    <span className="gradient-text">Core Competencies</span>
                  </h4>
                   {progressData?.map((progress) => (
                    <TrackVisibility
                      once
                      key={progress.id}
                      className="progress-wrapper"
                    >
                      <Skill progress={progress} />
                    </TrackVisibility>
                  ))}
                  <div className="mt-4 text-center">
                    <p className="text-muted small">
                      <i className="icon-badge"></i> Continuously improving through real-world projects and challenges
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
